import React from "react";

import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import { AdminNavbar } from "Components/UI/Navbar/AdminNavbar";
import { ClientsContextProvider } from "Context/Clients";
import { ArticlesContextProvider } from "Context/Articles";

export default function AdminLayout() {
  return (
    <>
      <ClientsContextProvider>
        <ArticlesContextProvider>
          <AdminNavbar />
          <Box
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === "light"
                  ? theme.palette.background
                  : theme.palette.background,
              flexGrow: 1,
            }}
          >
            <Outlet />
          </Box>
        </ArticlesContextProvider>
      </ClientsContextProvider>
    </>
  );
}
